import { apiClient } from "helpers/api_helper";

export const GetAllPurchaseOrderBaggingList = async (data: object) => {
  try {
    const response = await apiClient.get(
      `/api/v1/PurchaseOrder/GetPurchaseOrderItemBaggingList`
      , data);
    return response;
  } catch (error: any) {
    throw new Error(error.message);
  }
};

export const GeneratePurchaseOrderItemBagApi = async (
  purchaseOrderItemBaggingIds: any
) => {
  try {
    const response = await apiClient.post(
      `/api/v1/PurchaseOrder/GeneratePurchaseOrderItemBag`,
      purchaseOrderItemBaggingIds
    );
    return response;
  } catch (error: any) {
    throw new Error(error.message);
  }
};
